export const getPlatformControl = /* GraphQL */ `
    query GetPlatformControl($id: ID!) {
        getPlatformControl(id: $id) {
            id
            state
            lastChangedBy
            lastChangedAt
            flipLatencySeconds
        }
    }
`;
